import React from 'react';
import {
    ClosingCountdown,
    UploadedDocument,
    WireTransferGroup,
} from '../../../models/FlowOfFunds/flow-of-funds.model';
import { formatMoneyExact, wireGroupKey } from '../../../utils/flowOfFundsFormat';
import { WireGroupCard } from './WireGroupCard';
import { ClosingTickler } from '../ClosingTickler/ClosingTickler';
import './WireTransferSummary.scss';

export interface WireTransferSummaryProps {
    wireTransfers: WireTransferGroup[];
    totalDisbursementsAtClose: number | null;
    onViewWireInstructions: (group: WireTransferGroup) => void;
    onConfirmSent?: (group: WireTransferGroup, paymentDate: Date) => void;
    onUndoConfirmSent?: (group: WireTransferGroup) => void;
    onConfirmReceipt?: (group: WireTransferGroup) => void;
    onUndoConfirmReceipt?: (group: WireTransferGroup) => void;
    onUploadSenderEvidence?: (group: WireTransferGroup, file: File) => void;
    onRemoveSenderEvidence?: (group: WireTransferGroup) => void;
    onUploadReceiptEvidence?: (group: WireTransferGroup, file: File) => void;
    onRemoveReceiptEvidence?: (group: WireTransferGroup) => void;
    onViewDocument?: (group: WireTransferGroup, document: UploadedDocument) => void;
    pendingKey?: string | null;
    closing?: ClosingCountdown | null;
}

export const WireTransferSummary = ({
    wireTransfers,
    totalDisbursementsAtClose,
    onViewWireInstructions,
    onConfirmSent = () => {},
    onUndoConfirmSent = () => {},
    onConfirmReceipt = () => {},
    onUndoConfirmReceipt = () => {},
    onUploadSenderEvidence = () => {},
    onRemoveSenderEvidence = () => {},
    onUploadReceiptEvidence = () => {},
    onRemoveReceiptEvidence = () => {},
    onViewDocument = () => {},
    pendingKey = null,
    closing,
}: WireTransferSummaryProps) => (
    <div className="ff-wires">
        <div className="ff-wires__tickler-slot">
            <ClosingTickler closing={closing} />
        </div>

        {wireTransfers.map((group) => (
            <WireGroupCard
                key={wireGroupKey(group)}
                group={group}
                pendingKey={pendingKey}
                onViewWireInstructions={onViewWireInstructions}
                onConfirmSent={onConfirmSent}
                onUndoConfirmSent={onUndoConfirmSent}
                onConfirmReceipt={onConfirmReceipt}
                onUndoConfirmReceipt={onUndoConfirmReceipt}
                onUploadSenderEvidence={onUploadSenderEvidence}
                onRemoveSenderEvidence={onRemoveSenderEvidence}
                onUploadReceiptEvidence={onUploadReceiptEvidence}
                onRemoveReceiptEvidence={onRemoveReceiptEvidence}
                onViewDocument={onViewDocument}
            />
        ))}

        <div className="ff-wires__total">
            <span className="ff-wires__total-label">Total Disbursements at Close</span>
            <span className="ff-wires__total-value">
                {formatMoneyExact(totalDisbursementsAtClose)}
            </span>
        </div>
    </div>
);
